module.exports = __webpack_public_path__ + "img/GK.06a35928.jpg";